<div class="main-content">
  <div class="flex flex-col">
    <h1>Wybierz konto</h1>
    <div class="flex flex-col gap-1 mt-6 account-finder">
      <label for="organization">Wyszukaj</label>
      <input
        pInputText
        id="organization"
        class="w-full sm:w-1/4 account-search-custom-input"
        aria-describedby="organization"
        [ngModel]="searchTerm()"
        (ngModelChange)="searchTerm.set($event)"
      />
    </div>
  </div>
  <div class="flex flex-col">
    <h2 class="sectionHeader">Konto osobiste</h2>
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
      type="button"
    >
      <app-application-context-card
        (click)="setBeneficiaryContext()"
        (keypress)="setBeneficiaryContext($event)"
        [title]="'Konto osobiste'"
        [icon]="'pi pi-user'"
        [description]="'PESEL: ' + beneficjent().pesel"
      ></app-application-context-card>
    </div>
  </div>
  @if (filteredOrganizations().length > 0) {
    <div class="flex flex-col">
      <h2 class="sectionHeader">Konto organizacji</h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        @for (organization of visibleOrganizations(); track organization.id) {
          <app-application-context-card
            [title]="organization.nazwa"
            [description]="organization | organizationDescription"
            (click)="setOrganizationContext(organization)"
            (keypress)="setOrganizationContext(organization, $event)"
            [icon]="'pi pi-briefcase'"
          ></app-application-context-card>
        }
      </div>
      @if (filteredOrganizations().length > 4) {
        <p-button
          type="button"
          [label]="showMore() ? 'Pokaż mniej' : 'Pokaż więcej'"
          [icon]="showMore() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          (click)="toggleShowMore()"
          class="mt-4 customShowMoreButton"
          [rounded]="true"
          [text]="true"
        >
        </p-button>
      }
    </div>
  }
  @if (isUserAdmin()) {
    <div class="flex flex-col">
      <h2 class="sectionHeader">Konto administratora</h2>
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
        type="button"
      >
        <app-application-context-card
          (click)="setAdministratorContext()"
          (keypress)="setAdministratorContext($event)"
          [title]="'Konto administratora'"
          [icon]="'pi pi-cog'"
        ></app-application-context-card>
      </div>
    </div>
  }
</div>
